"use client";

import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "@/lib/utils";

const SeparatorWithLabel = ({
  label,
  labelClassName,
  className,
  ...props
}: React.ComponentProps<typeof Separator>) => {
  return (
    <div className={cn("flex items-center gap-4", className)}>
      <Separator className="flex-1" {...props} />
      <span
        className={cn("text-grey-400 text-sm leading-[130%]", labelClassName)}
      >
        {label}
      </span>
      <Separator className="flex-1" {...props} />
    </div>
  );
};

export const Separator = ({
  className,
  label,
  labelClassName,
  orientation = "horizontal",
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root> & {
  label?: string;
  labelClassName?: string;
}) => {
  if (label) {
    return (
      <SeparatorWithLabel
        label={label}
        labelClassName={labelClassName}
        className={className}
        decorative={decorative}
        orientation={orientation}
        {...props}
      />
    );
  }

  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "bg-grey-300 shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        className,
      )}
      {...props}
    />
  );
};
